<template>
  <div>
    <div class="max-w-5xl mx-auto space-y-16">
      <AdListComponent :fetching="fetching" :ads="ads" :meta="meta" @get-ads="handleGetAds" />
    </div>
  </div>
</template>

<script>
import { facebookCampaignAdComputed, facebookCampaignAdMethods } from '@/store/adminHelper';
import AdListComponent from '@/components/FacebookAds/List.vue';

export default {
  name: 'AdList',
  components: {
    AdListComponent,
  },
  props: {
    facebookCampaignId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...facebookCampaignAdComputed,
  },
  created() {
    this.handleGetAds();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...facebookCampaignAdMethods,
    async handleGetAds(queryParams = {}) {
      const { facebookCampaignId } = this;
      this.fetching = true;
      try {
        await this.getFacebookCampaignAds({
          facebookCampaignId,
          queryParams: {
            ...queryParams,
            include: 'lifetimeReport',
          },
        });
      } catch (error) {
        //
      } finally {
        this.fetching = false;
      }
    },
  },
};
</script>
